define('controllers/modules/calendar/calendar',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Contollers
    'src/controller/controller',
    'controllers/modules/calendar/item/activity',
    'controllers/modules/calendar/item/session',
    'controllers/modules/calendar/item/nutrition',
    'controllers/modules/calendar/item/personal-data',
    'controllers/modules/template/template',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // controller
    Controller,
    CalendarActivityCtrl,
    CalendarSessionCtrl,
    CalendarNutritionCtrl,
    CalendarPersonalDataCtrl,
    TemplateCtrl
) {

    var CalendarCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*calendar': 'index',
        },

        /**
         * 'date' must be in the explicit format: yyyy/mm/dd
         */
        subRoutes: {
            activity: '{{{dayId}}}/activity/',
            session: '{{{dayId}}}/animated/',
            nutrition: '{{{dayId}}}/nutrilog/',
            personalData: '{{{dayId}}}/custom_data/',
            template: '{{{dayId}}}/template/'
        },

        initialize: function(prefix, opt) {

            _.extend(this, {
                events: {
                    "before:route": this.onBeforeSubRoute,
                    "back": this.onBack,
                },
                ctrl: {},
                role: opt.role,
                conversation: opt.conversation ? opt.conversation : {}
            });

            this.initSubController("activity", CalendarActivityCtrl);
            this.initSubController("session", CalendarSessionCtrl);
            this.initSubController("nutrition", CalendarNutritionCtrl);
            this.initSubController("personalData", CalendarPersonalDataCtrl);
            this.initSubController("template", TemplateCtrl);
        },

        initSubController: function(key, CtrlClass) {
            var ctrl = this.ctrl[key] = new CtrlClass(
                this.getPrefix(key, {
                    dayId: ":dayId"
                }), {
                    layout: this.layoutCtrl,
                    url: this.url[key],
                    role: this.role,
                });
            this.listenTo(ctrl, this.events);
        },

        index: function(groupId, userId) {
            this.getLayout().getContent().toggleInfo(false);
        },

        ////////////
        // events //
        ////////////
        onBack: function() {
            Backbone.history.navigate(
                Mustache.render(this.url.root, {
                    userId: this.profile.id,
                    groupId: this.group.id,
                    conversationId: this.conversation.id
                }), { trigger: true });
        },

        onBeforeSubRoute: function(route, params) {
            this.trigger("before:route", route, params);
        },

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },

    });

    return CalendarCtrl;
});

